"use strict";

reportCreator.classy.controller({
	name: "MainReportCreatorSideNavController",
	inject: ["$scope", "ArchiveYearsService", "ReportCreatorService", "SchoolModelService", "DateService", "authServiceFactory"],
	init: function()
	{
		this.$.authServiceFactory = this.authServiceFactory;
		this.$.ReportCreatorService = this.ReportCreatorService;
		this.$.ReportCreatorService.reporttype = '';
		var parent = this;
		this.SchoolModelService.resolveData().then(function() {
			var archiveyears = parent.ArchiveYearsService.get();
			parent.$.years = [{"App_Fin_Year": parent.DateService.getCurrentYear()}];
			parent.$.years = parent.$.years.concat(archiveyears);

			parent.$.loading = false;
			parent.$.form = {};
			parent.$.form.SB = "ALL";
			parent.$.form.Op = "GT";
			parent.$.form.SCY = parent.$.years[0].App_Fin_Year; //Get Current Year
			parent.$.form.fl = "";
			parent.$.form.Am = "";
			parent.$.ReportCreatorService = parent.ReportCreatorService;

		})
		
	}
});
